import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "../../components/ui/CustomButton";
import InputFormField from "../../components/ui/inputs/InputFormField";
import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { getUserFromLocalStorage, updateUserNamesInLocalStorage } from "../../utils/helper";
import { updateUserName } from "../../firebase/firebase";
import { useEffect, useState, useCallback } from "react";

const editNameScheme = z.object({
  name: z
    .string()
    .min(1, "Name is required")
});

type EditNameScheme = z.infer<typeof editNameScheme>;

interface EditNameDialogProps {
    open: boolean;
    onClose: (value: string) => void;
    selectedValue: string;
}

const EditNameDialog = (props: EditNameDialogProps) => {
    const { onClose, selectedValue, open} = props;
    const [saveChanges, setSaveChanges] = useState(false);
    
    const formData = useForm<EditNameScheme>({
        mode: "onBlur",
        resolver: zodResolver(editNameScheme),
        defaultValues: {
            name: selectedValue,
        },
    });
    
    
    const handleClose = useCallback(() => {
        if (saveChanges) {
            const user = getUserFromLocalStorage();
            if (selectedValue !== formData.getValues().name) {
                updateUserName(user.uid, formData.getValues().name);
                updateUserNamesInLocalStorage(formData.getValues().name);
                onClose(formData.getValues().name);
            }
            setSaveChanges(false);
            onClose(selectedValue);
        } else {
            onClose(selectedValue);
        }
    }, [saveChanges, selectedValue, formData, onClose]);


    useEffect(() => {
        if (saveChanges) {
            console.log("saving changes")
            handleClose();
        }
    }, [saveChanges, handleClose]);


  return (
    <Dialog onClose={handleClose} open={open}>
      <div className="m-10">
        <DialogTitle id="simple-dialog-title" className="flex flex-row items-center justify-center">Edit Name</DialogTitle>
        <FormProvider {...formData}>
          <InputFormField
            name="name"
            label="Name"
            placeholder="Update your name"
            className="mt-3 mb-3"
            onChange={(e) => {
                formData.setValue("name", e.target.value);
            }}
          />
        </FormProvider>
        <div className="flex flex-row justify-end">
          <Button
            className="mt-3 mb-3"
            onClick={() => {
                setSaveChanges(true);
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default EditNameDialog;
